import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { PercentageSymbolPipe } from './../../../modules/shared/pipes/percentage-symbol.pipe';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { DashboardService } from '../../../profile/dashboard/services/dashboard.service';
import { FormErrorHandler } from 'src/app/modules/shared/helpers/form-error-handler.helper';
import { ReportsAllFiltersApplyModes, ReportsAllFiltersAppyModels, typeReportsAllFiltersApplyModes } from 'src/app/reports/models/reports-all-filter-appy.models';
import { ReportService } from 'src/app/reports/reportService';
import { DATE_RANGE_LIST } from '../../../modules/shared/constants/date-range-list.constants';
import { scrollToError } from '../../../modules/shared/helpers/scroll-to-error.helper';
import { DateRangeFilterService } from '../../../modules/shared/services/date-range-filter.service';
import { TimeZoneService } from '../../../modules/shared/services/timezone.service';
import { CurrencySymbolPipe } from 'src/app/modules/shared/pipes/currency-symbol.pipe';

@Component({
    selector: 'app-dashboard-whatsapp-reports',
    templateUrl: './dashboard-whatsapp-reports.component.html',
    styleUrls: ['./dashboard-whatsapp-reports.component.scss'],
    providers: [DatePipe,CurrencySymbolPipe,PercentageSymbolPipe]
})

export class DashboardWhatsappReportsComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() selectedReportFilters: any = null;
    @Input() reloadContent: boolean = false;
    @Output() onReloadContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onLastReloadTime: EventEmitter<any> = new EventEmitter<Date>();
    @Input() selectedWindow: string = '';
    @Input() displayFilterPopup: boolean = false;
    @Output() onCloseFilterPopup: EventEmitter<any> = new EventEmitter<any>();
    @Output() onUpdateAllFilters: EventEmitter<ReportsAllFiltersAppyModels> = new EventEmitter<ReportsAllFiltersAppyModels>();

    filterDataByTime = DATE_RANGE_LIST;
    reportsAllFiltersApplyModes = ReportsAllFiltersApplyModes;
    reportName: string = "";
    filterPopupHeader: string = "Filter";
    savedReportFilters: any = null;
    filterForm: FormGroup = new FormGroup({});
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();

    //Report
    loadingReport: boolean = false;
    reportResultValue: number = 0;

    //Finance Chart
    chartLabel: string = "Time";
    chartBottomLabel: string = "Period";
    barChartbasicOptions: any;
    barChartData: any = null;

    resultsData: any[] = [];

    constructor(
        private formBuilder: FormBuilder,
        private timezoneService: TimeZoneService,
        private datePipe: DatePipe,
        private reportService: ReportService,
        private dashboardService: DashboardService,
        private dateRangeFilterService: DateRangeFilterService,
        private currencySymbolPipe: CurrencySymbolPipe,
        private percentageSymbolPipe: PercentageSymbolPipe
    ){}

    ngOnInit(): void {
    }


    ngOnChanges(changes: SimpleChanges){

        if(changes?.selectedWindow && changes.selectedWindow?.currentValue){
            this.selectedWindow = changes.selectedWindow.currentValue;
        }

        if(changes?.selectedReportFilters && changes.selectedReportFilters?.currentValue){
            this.selectedReportFilters = changes.selectedReportFilters?.currentValue||false;
            this.savedReportFilters = ParseHelper.DeepCopy(this.selectedReportFilters);
            this.setFilterDetails(true);
        }

        if(changes?.displayFilterPopup){
            this.displayFilterPopup = changes.displayFilterPopup?.currentValue||false;
            if(this.displayFilterPopup){
                this.setFilterDetails();
            }
        }

        if(changes?.reloadContent && changes?.reloadContent?.currentValue){
            this.reloadContent = true;
            this.selectedReportFilters = ParseHelper.DeepCopy(this.savedReportFilters);
            this.setFilterDetails(true);
        }
    }

    setFilterDetails(reloadReport: boolean = false){
        this.initFieldForm();
        const selectedDateFilter = this.filterDataByTime.find(d=> d.code === this.selectedReportFilters.dateFilter);
        this.reportName = this.selectedReportFilters?.summaryWidgetTitle;
        this.filterForm.patchValue({
            selectedDateFilter: selectedDateFilter,
            dateFrom: this.selectedReportFilters?.fromDate ? new Date(this.selectedReportFilters?.fromDate) : null,
            dateTo:  this.selectedReportFilters?.toDate ? new Date(this.selectedReportFilters?.toDate) : null
        });
        this.changeRange({value: selectedDateFilter});

        let periodTitle = "";

        if(selectedDateFilter?.code=='custom'){
            periodTitle = `${this.datePipe.transform(this.filterForm.getRawValue().dateFrom, 'MMM d, yy')} - ${this.datePipe.transform(this.filterForm.getRawValue().dateTo, 'MMM d, yy')}`;
        }else if(selectedDateFilter?.label){
            periodTitle = selectedDateFilter?.label;
        }

        if(reloadReport){
            this.barChartData = null;
            this.resultsData = [];

            const globalThis = this;
            this.barChartbasicOptions = {
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                responsive: true,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function(context) {
                                let label = context.dataset.label || '';

                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += context.parsed.y;
                                }
                                return label;
                            }
                        }
                    },
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                },
                scales: {
                    x: {
                        stacked: true,
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef'
                        }
                    },
                    y: {
                        stacked: true,
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef'
                        }
                    }
                }
            };

            this.getAllReportsData();

            this.chartBottomLabel = periodTitle;
        }
    }

    initFieldForm(){
        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        this.filterForm = this.formBuilder.group({
            selectedDateFilter: [null, [Validators.required]],
            dateFrom: [null, [Validators.required]],
            dateTo: [null]
        });

        this.formErrorHandler.handleErrors(this.filterForm, this.detailsFormErrors, {
            selectedDateFilter: {
                required: "Select period",
            }
        });
    }

    changeRange($event): void {
        const selectedDateFilter = $event.value;
        let dateFrom = null;
        let dateTo = null;

        let data = {
            code: selectedDateFilter.code,
            fromDate: this.filterForm.getRawValue().dateFrom,
            toDate: this.filterForm.getRawValue().dateTo
        };
        const dateRange = this.dateRangeFilterService.changeRange(data);
        dateFrom = dateRange?.fromDate;
        dateTo = dateRange?.toDate;

        this.filterForm.patchValue({
            dateFrom: dateFrom,
            dateTo: dateTo
        });
    }

    cancelFilterPopup(){
        this.displayFilterPopup = false;
        this.onCloseFilterPopup.emit();
    }

    applyAllFilters(applyMode: typeReportsAllFiltersApplyModes) {

        if (this.filterForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            scrollToError();
            return; //Return if form invalid
        }

        const formValue = this.filterForm.getRawValue();

        let allFiltersValue: ReportsAllFiltersAppyModels = {
            applyMode: applyMode,
            dateFilter: {
                label: formValue.selectedDateFilter?.label,
                code: formValue.selectedDateFilter?.code,
                fromDate: formValue.dateFrom,
                toDate: formValue.dateTo
            }
        }

        this.selectedReportFilters = {
            ...this.selectedReportFilters,
            ...allFiltersValue,
            ...allFiltersValue.dateFilter,
            dateFilter: allFiltersValue.dateFilter.code
        }
        if(applyMode==ReportsAllFiltersApplyModes.applySave){
            this.savedReportFilters = ParseHelper.DeepCopy(this.selectedReportFilters);
        }
        this.setFilterDetails(true);

        this.onUpdateAllFilters.emit(allFiltersValue);
        this.cancelFilterPopup();
    }

    getAllReportsData() {
        this.loadingReport = true;
        let api: any;
        let valueProperty: string = "time";
        switch(this.selectedWindow){
            case 'whatsappavgresponsetime':
                valueProperty = "time";
                this.chartLabel = "Average Response Time (Minutes)";
                api = this.reportService
                .getWhatsappAvgResponseTime(this.formatDate(this.filterForm.getRawValue().dateFrom), this.formatDate(this.filterForm.getRawValue().dateTo));
                break;
            case 'whatsappavgconresponsetime':
                valueProperty = "time";
                this.chartLabel = "Average Conversation Response Time (Minutes)";
                api = this.reportService
                .getWhatsappConvAvgResponseTime(this.formatDate(this.filterForm.getRawValue().dateFrom), this.formatDate(this.filterForm.getRawValue().dateTo));
                break;
            case 'whatsappresponsecount':
                valueProperty = "count";
                this.chartLabel = "Average Response Count By Rep";
                api = this.reportService
                .getWhatsappResponseCount(this.formatDate(this.filterForm.getRawValue().dateFrom), this.formatDate(this.filterForm.getRawValue().dateTo));
                break;
            case 'whatsappquerycount':
                valueProperty = "count";
                this.chartLabel = "Query Count";
                api = this.reportService
                .getWhatsappQueryCount(this.formatDate(this.filterForm.getRawValue().dateFrom), this.formatDate(this.filterForm.getRawValue().dateTo));
                break;
        }

        if(api){
            api.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.onReloadContent.emit(false);
                    this.loadingReport = false;
                    this.reportResultValue = 0;
                    this.resultsData = res||[];
                    this.generateBarChart(this.resultsData,valueProperty);
                },
                (err) => {
                    this.onReloadContent.emit(false);
                    this.loadingReport = false;
                }
            );
        }
    }

    generateBarChart(reportsData: any[], valueProperty: string, backgroundColor: string = '#42A5F5'){
        const stageChart = {
            labels: [],
            datasets: [
                {
                    label: this.chartLabel,
                    backgroundColor: backgroundColor,
                    data: []
                },
            ]
        }
        this.barChartData = stageChart;
        if (!reportsData || !reportsData.length) {
            return;
        }

        reportsData.map(data=>{
            let name = data.name;
            if(this.selectedWindow=='whatsappquerycount' && data?.phoneNumber){
                name = `${data.name}(${data?.phoneNumber})`
            }
            stageChart.labels.push(name);
            stageChart.datasets[0].data.push(data[valueProperty]||0);
        })
        this.barChartData = stageChart;
    }

    private formatDate(date: Date): any {
        date = date ? date : new Date();
        let utcDate = this.datePipe.transform(this.timezoneService.saveDateTimeWithZone(date), "MM-dd-yyyy");
        return utcDate;
    }

    private formatDate2(date: Date): any {
        let utcDate = this.datePipe.transform(date, "MM-dd-yyyy");
        return utcDate;
    }

    randColor(numColors) {
        const chars = "ABCDEF0123456789";
        const size = chars.length;
        let str = [];

        for(let i = 0; i < numColors; i++ ) {
            str[i] = "#";
            for(let j = 0; j < 6; j++ ) {
                const rand = Math.floor(Math.random() * (size - 1)) + 1;
                str[i] += chars[rand];
            }
        }
        return str;
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
